const validate = values => {
	const errors = {}
	if (!values.warranty_type) {
		errors.warranty_type = 'Este campo es obligatorio'
	}
	return errors
}

export default validate



/** WEBPACK FOOTER **
 ** ./src/components/Validations/submitValidationsWarrantyForm.js
 **/